import { chain, unset } from 'icepick';
import {
	ISSUE_PARENT_PANEL,
	VERSION_PANEL,
	INSIGHTS_PANEL,
	VIEW_SETTINGS_PANEL,
} from '../../../../model/panels/constants.tsx';
import {
	isIssueParentPanelOpen,
	isVersionPanelOpen,
	isInsightsPanelOpen,
} from '../../../../services/panel/index.tsx';
import {
	type Action,
	TOGGLE_PANEL,
	CLOSE_INSIGHTS_PANEL,
	SET_ALL_PANELS_SUCCESS,
	CLOSE_VIEW_SETTINGS_PANEL,
} from '../../../actions/panels/index.tsx';
import type { PanelState } from './types.tsx';

const initialState = (): PanelState => ({
	[ISSUE_PARENT_PANEL]: isIssueParentPanelOpen(),
	[VERSION_PANEL]: isVersionPanelOpen(),
	[INSIGHTS_PANEL]: isInsightsPanelOpen(),
	[VIEW_SETTINGS_PANEL]: false,
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: PanelState = initialState(), action: Action): PanelState => {
	switch (action.type) {
		case TOGGLE_PANEL: {
			const {
				payload: { panel },
			} = action;

			return state[panel] === true ? unset(state, panel) : chain(state).set(panel, true).value();
		}

		case CLOSE_INSIGHTS_PANEL: {
			return unset(state, INSIGHTS_PANEL);
		}

		case CLOSE_VIEW_SETTINGS_PANEL: {
			return unset(state, VIEW_SETTINGS_PANEL);
		}

		case SET_ALL_PANELS_SUCCESS:
			return action.payload.panels;

		default:
			return state;
	}
};
